import {Program} from './program';
import {StorageService} from '../services/storage.service';

/**
 * Created by strunz on 11.05.2017.
 */

export class Product {
    name: string;
    programs: Program[] = Array();

    constructor(productData, private storageService: StorageService) {
        this.name = productData.name;
        for (const programData of productData.programs) {
            const programObject = new Program(programData, this.storageService);
            this.programs.push(programObject);
        }
    }
}
